import {
  CreateEnvironmentCopyRequestRequest,
  CreateEnvironmentCopyRequestResponse,
  UpdateEnvironmentCopyRequestRequest,
  UpdateEnvironmentCopyRequestResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface DeploymentRequestRestResource {
  createEnvironmentCopyRequest(
    request: CreateEnvironmentCopyRequestRequest,
  ): Promise<CreateEnvironmentCopyRequestResponse>;
  updateEnvironmentCopyRequest(
    request: UpdateEnvironmentCopyRequestRequest,
  ): Promise<UpdateEnvironmentCopyRequestResponse>;
}

const REST_RESOURCE_NAME = "/environment-copy-request";

/**
 * PUT /environment-copy-request
 */
const createEnvironmentCopyRequest = restResourceRequester<
  CreateEnvironmentCopyRequestRequest,
  CreateEnvironmentCopyRequestResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /environment-copy-request/cancel
 */
const updateEnvironmentCopyRequest = restResourceRequester<
  UpdateEnvironmentCopyRequestRequest,
  UpdateEnvironmentCopyRequestResponse
>(
  "PUT",
  (request) =>
    `${REST_RESOURCE_NAME}/cancel/${request.envrnmntCopyDplymntReqSeqNum}`,
  (request) => JSON.stringify(request),
);

export const DeploymentRequestRestResource: DeploymentRequestRestResource = {
  createEnvironmentCopyRequest: createEnvironmentCopyRequest,
  updateEnvironmentCopyRequest: updateEnvironmentCopyRequest,
};
